// extracted by mini-css-extract-plugin
export default {"technologies":"technologies_technologies__S0RC+","technologies_icon":"technologies_technologies_icon__x0Wjn"};